import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import env from "config/env";
import { getUserIdToken } from "utils/auth/cognitoAuthToolkit";

const API_VERSION = "v8";

const base: AxiosInstance = axios.create({
  baseURL: `${env.end_point_url.slid_api}/${API_VERSION}`,
  withCredentials: false,
});

base.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    const cognitoIdToken = await getUserIdToken();

    if (cognitoIdToken) {
      config.headers["Authorization"] = `${cognitoIdToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default base;
